import { createContext, useContext } from 'react';
const HeaderContext = createContext(undefined);
export const HeaderProvider = HeaderContext.Provider;
export const useHeaderHandlers = () => {
  const context = useContext(HeaderContext);
  return context?.handlers ?? {};
};